// Format date in a form of '2024 / 25' to '2024/2025'
export const formatAcademicYear = (year: string) => {
    const [startYear, endYear] = year.split(' / ');
    const formattedEndYear = `20${endYear}`;

    return `${startYear}/${formattedEndYear}`;
};
